(() => {
  if (window.__B45_PAGE_SCRIPT_LOADED__) return;
  window.__B45_PAGE_SCRIPT_LOADED__ = true;

  const money = (cents) => new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD'
  }).format((Number(cents) || 0) / 100);

  const q = (root, selector) => root ? root.querySelector(selector) : null;
  const qa = (root, selector) => root ? Array.from(root.querySelectorAll(selector)) : [];
  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));

  function initHero(root) {
    const hero = q(
      root,
      '[data-b45-hero]'
    );

    if (
      !hero ||
      hero.dataset.b45Ready === 'true'
    ) {
      return;
    }

    hero.dataset.b45Ready = 'true';

    const mainImage = q(
      hero,
      '[data-b45-main-image]'
    );

    const visual = q(
      hero,
      '[data-b45-main-visual]'
    );

    qa(
      hero,
      '[data-b45-thumb]'
    ).forEach((thumb) => {
      thumb.addEventListener(
        'click',
        () => {
          qa(
            hero,
            '[data-b45-thumb]'
          ).forEach((item) => {
            item.classList.remove(
              'active'
            );
          });

          thumb.classList.add(
            'active'
          );

          const url =
            thumb.dataset.imageUrl;

          if (!mainImage || !url) {
            return;
          }

          mainImage.style.opacity =
            '.15';

          window.setTimeout(() => {
            mainImage.src = url;

            mainImage.alt =
              thumb.dataset.imageAlt ||
              mainImage.alt;

            mainImage.style.opacity =
              '1';
          }, 150);
        }
      );
    });

    if (
      visual &&
      mainImage &&
      window
        .matchMedia('(pointer:fine)')
        .matches
    ) {
      visual.addEventListener(
        'pointermove',
        (event) => {
          const rect =
            visual.getBoundingClientRect();

          const x =
            (
              event.clientX -
              rect.left
            ) /
            rect.width -
            0.5;

          const y =
            (
              event.clientY -
              rect.top
            ) /
            rect.height -
            0.5;

          mainImage.style.transform =
            `scale(1.06) translate(${x * -14}px, ${y * -10}px)`;
        }
      );

      visual.addEventListener(
        'pointerleave',
        () => {
          mainImage.style.transform =
            'scale(1)';
        }
      );
    }

    const form = q(
      hero,
      '.b45-product-form'
    );

    const variantsScript = q(
      root,
      '[data-b45-variants]'
    );

    const optionsScript = q(
      root,
      '[data-b45-option-names]'
    );

    if (
      !form ||
      !variantsScript ||
      !optionsScript
    ) {
      return;
    }

    let variants = [];
    let optionNames = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent ||
        '[]'
      );

      optionNames = JSON.parse(
        optionsScript.textContent ||
        '[]'
      );
    } catch (error) {
      console.error(
        'Buffalo 45 variant data could not be read.',
        error
      );

      return;
    }

    if (
      !Array.isArray(variants) ||
      !variants.length
    ) {
      console.error(
        'Buffalo 45 has no readable variants.'
      );

      return;
    }

    const normalise = (value) =>
      String(value ?? '').trim();

    const numericMetres = (value) => {
      const match =
        normalise(value)
          .match(/[\d.]+/);

      return match
        ? Number(match[0])
        : 0;
    };

    const sameOption = (
      left,
      right
    ) =>
      normalise(left) ===
      normalise(right);

    const detectedWidthIndex =
      optionNames.findIndex(
        (name) =>
          normalise(name)
            .toLowerCase()
            .includes('width')
      );

    const detectedLengthIndex =
      optionNames.findIndex(
        (name) =>
          normalise(name)
            .toLowerCase()
            .includes('length')
      );

    const widthIndex =
      detectedWidthIndex >= 0
        ? detectedWidthIndex
        : 0;

    const lengthIndex =
      detectedLengthIndex >= 0
        ? detectedLengthIndex
        : Math.min(
            1,
            Math.max(
              0,
              optionNames.length - 1
            )
          );

    const widthButtons = qa(
      hero,
      '[data-b45-width]'
    );

    const lengthSelect = q(
      hero,
      '[data-b45-length]'
    );

    const variantInput = q(
      form,
      'input[name="id"]'
    );

    const quantityInput = q(
      form,
      'input[name="quantity"]'
    );

    const quantityOutput = q(
      hero,
      '[data-b45-qty-output]'
    );

    const addButton = q(
      form,
      '[data-b45-add]'
    );

    const stickyAdd = q(
      root,
      '[data-b45-sticky-add]'
    );

    if (
      !widthButtons.length ||
      !lengthSelect ||
      !variantInput ||
      !quantityInput
    ) {
      return;
    }

    const variantWidthValues = [
      ...new Set(
        variants
          .map(
            (variant) =>
              normalise(
                variant.options?.[
                  widthIndex
                ]
              )
          )
          .filter(Boolean)
      )
    ].sort(
      (a, b) =>
        numericMetres(a) -
        numericMetres(b)
    );

    widthButtons.forEach(
      (button) => {
        const currentValue =
          normalise(
            button.dataset
              .optionValue
          );

        const currentNumber =
          numericMetres(
            currentValue ||
            button.textContent
          );

        const exact =
          variantWidthValues.find(
            (value) =>
              sameOption(
                value,
                currentValue
              )
          );

        const numericMatch =
          variantWidthValues.find(
            (value) =>
              numericMetres(value) ===
              currentNumber
          );

        const resolved =
          exact ||
          numericMatch;

        if (resolved) {
          button.dataset.optionValue =
            resolved;
        }
      }
    );

    let activeWidthButton =
      widthButtons.find(
        (button) =>
          button.classList.contains(
            'active'
          )
      );

    if (
      !activeWidthButton ||
      !variantWidthValues.some(
        (value) =>
          sameOption(
            value,
            activeWidthButton
              .dataset.optionValue
          )
      )
    ) {
      activeWidthButton =
        widthButtons.find(
          (button) =>
            numericMetres(
              button.dataset
                .optionValue
            ) === 4
        ) ||
        widthButtons[0];
    }

    widthButtons.forEach(
      (button) =>
        button.classList.toggle(
          'active',
          button ===
            activeWidthButton
        )
    );

    let quantity =
      Math.max(
        1,
        Number(
          quantityInput.value ||
          1
        )
      );

    let preferredLengthNumber =
      numericMetres(
        lengthSelect.value
      ) ||
      10;

    function selectedWidth() {
      return normalise(
        widthButtons.find(
          (button) =>
            button.classList.contains(
              'active'
            )
        )?.dataset.optionValue
      );
    }

    function availableLengthValues(
      widthValue
    ) {
      const values =
        variants
          .filter(
            (variant) =>
              sameOption(
                variant.options?.[
                  widthIndex
                ],
                widthValue
              )
          )
          .map(
            (variant) =>
              normalise(
                variant.options?.[
                  lengthIndex
                ]
              )
          )
          .filter(
            (value) =>
              value &&
              numericMetres(value) > 0
          );

      return [
        ...new Set(values)
      ].sort(
        (a, b) =>
          numericMetres(a) -
          numericMetres(b)
      );
    }

    function rebuildLengthOptions(
      preferredNumber =
        preferredLengthNumber
    ) {
      const lengths =
        availableLengthValues(
          selectedWidth()
        );

      const previousValue =
        normalise(
          lengthSelect.value
        );

      lengthSelect.innerHTML =
        '';

      lengths.forEach(
        (value) => {
          const option =
            document.createElement(
              'option'
            );

          option.value =
            value;

          option.textContent =
            value;

          lengthSelect.appendChild(
            option
          );
        }
      );

      const exactPrevious =
        lengths.find(
          (value) =>
            sameOption(
              value,
              previousValue
            )
        );

      const preferred =
        lengths.find(
          (value) =>
            numericMetres(value) ===
            preferredNumber
        );

      lengthSelect.value =
        exactPrevious ||
        preferred ||
        lengths[0] ||
        '';

      preferredLengthNumber =
        numericMetres(
          lengthSelect.value
        ) ||
        preferredLengthNumber;
    }

    function selectedLength() {
      return normalise(
        lengthSelect.value
      );
    }

    function findVariant() {
      const width =
        selectedWidth();

      const length =
        selectedLength();

      return (
        variants.find(
          (variant) => {
            const options =
              variant.options ||
              [];

            return (
              sameOption(
                options[
                  widthIndex
                ],
                width
              ) &&
              sameOption(
                options[
                  lengthIndex
                ],
                length
              )
            );
          }
        ) ||
        null
      );
    }

    function updateOrder() {
      const variant =
        findVariant();

      const width =
        numericMetres(
          selectedWidth()
        );

      const length =
        numericMetres(
          selectedLength()
        );

      const area =
        width *
        length;

      const totalArea =
        area *
        quantity;

      const totalPrice =
        variant
          ? Number(
              variant.price
            ) *
            quantity
          : 0;

      /*
        Preserve the customer's actual
        Shopify variant selection.
      */

      variantInput.value =
        variant?.id ||
        '';

      quantityInput.value =
        String(quantity);

      if (quantityOutput) {
        quantityOutput.textContent =
          String(quantity);
      }

      const pieceSize = q(
        hero,
        '[data-b45-piece-size]'
      );

      const pieceArea = q(
        hero,
        '[data-b45-piece-area]'
      );

      const totalAreaEl = q(
        hero,
        '[data-b45-total-area]'
      );

      const totalPriceEl = q(
        hero,
        '[data-b45-total-price]'
      );

      const buttonPrice = q(
        hero,
        '[data-b45-button-price]'
      );

      const stickyPrice = q(
        root,
        '[data-b45-sticky-price]'
      );

      const stickyDetails = q(
        root,
        '[data-b45-sticky-details]'
      );

      if (pieceSize) {
        pieceSize.textContent =
          `${width}m × ${length}m`;
      }

      if (pieceArea) {
        pieceArea.textContent =
          `${area}m²`;
      }

      if (totalAreaEl) {
        totalAreaEl.textContent =
          `${totalArea}m²`;
      }

      if (totalPriceEl) {
        totalPriceEl.textContent =
          money(totalPrice);
      }

      if (buttonPrice) {
        buttonPrice.textContent =
          money(totalPrice);
      }

      if (stickyPrice) {
        stickyPrice.textContent =
          money(totalPrice);
      }

      if (stickyDetails) {
        stickyDetails.textContent =
          `${width}m × ${length}m · ${totalArea}m²`;
      }

      const available =
        Boolean(
          variant &&
          variant.available
        );

      if (addButton) {
        addButton.disabled =
          !available;

        addButton.setAttribute(
          'aria-disabled',
          String(!available)
        );
      }

      if (stickyAdd) {
        stickyAdd.disabled =
          !available;

        stickyAdd.setAttribute(
          'aria-disabled',
          String(!available)
        );
      }
    }

    widthButtons.forEach(
      (button) => {
        button.addEventListener(
          'click',
          () => {
            widthButtons.forEach(
              (item) =>
                item.classList.remove(
                  'active'
                )
            );

            button.classList.add(
              'active'
            );

            rebuildLengthOptions(
              preferredLengthNumber
            );

            updateOrder();
          }
        );
      }
    );

    lengthSelect.addEventListener(
      'change',
      () => {
        preferredLengthNumber =
          numericMetres(
            lengthSelect.value
          ) ||
          preferredLengthNumber;

        updateOrder();
      }
    );

    q(
      hero,
      '[data-b45-qty-minus]'
    )?.addEventListener(
      'click',
      () => {
        quantity =
          Math.max(
            1,
            quantity - 1
          );

        updateOrder();
      }
    );

    q(
      hero,
      '[data-b45-qty-plus]'
    )?.addEventListener(
      'click',
      () => {
        quantity =
          Math.min(
            99,
            quantity + 1
          );

        updateOrder();
      }
    );

    /*
      ADD TO CART

      Buffalo only selects the correct Shopify variant and quantity.
      The existing Shopify/theme cart system handles the actual cart add.
    */

    form.addEventListener(
      'submit',
      () => {
        const variant = findVariant();

        if (!variant || !variant.available) {
          return;
        }

        variantInput.value = String(variant.id);
        quantityInput.value = String(quantity);
      }
    );

        const attachRosyzAjaxCart = () => {
      if (
        form.dataset.b45AjaxCartReady === 'true'
      ) {
        return true;
      }

      if (
        !window.jQuery ||
        typeof window.AjaxCart !== 'function'
      ) {
        return false;
      }

      try {
        new window.AjaxCart(
          window.jQuery(form)
        );

        form.dataset.b45AjaxCartReady =
          'true';

        return true;
      } catch (error) {
        console.error(
          'Buffalo 45 AjaxCart could not initialise.',
          error
        );

        return false;
      }
    };

    if (!attachRosyzAjaxCart()) {
      let ajaxCartAttempts = 0;

      const ajaxCartTimer =
        window.setInterval(() => {
          ajaxCartAttempts += 1;

          if (
            attachRosyzAjaxCart() ||
            ajaxCartAttempts >= 50
          ) {
            window.clearInterval(
              ajaxCartTimer
            );
          }
        }, 100);
    }
  }

  function initCompare(root) {
    qa(
      root,
      '[data-b45-compare]'
    ).forEach((compare) => {
      if (
        compare.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      compare.dataset.b45Ready =
        'true';

      const range = q(
        compare,
        'input[type="range"]'
      );

      range?.addEventListener(
        'input',
        () =>
          compare.style.setProperty(
            '--pos',
            `${range.value}%`
          )
      );
    });
  }

  function initReveal(root) {
    const items = qa(
      root,
      '.reveal:not([data-b45-reveal-ready])'
    );

    if (!items.length) {
      return;
    }

    const observer =
      new IntersectionObserver(
        (entries) => {
          entries.forEach(
            (entry) => {
              if (
                entry.isIntersecting
              ) {
                entry.target.classList.add(
                  'visible'
                );

                observer.unobserve(
                  entry.target
                );
              }
            }
          );
        },
        {
          threshold: 0.1
        }
      );

    items.forEach(
      (item) => {
        item.dataset.b45RevealReady =
          'true';

        observer.observe(
          item
        );
      }
    );
  }

  function initLayer(root) {
    qa(
      root,
      '[data-b45-layer-section]'
    ).forEach((section) => {
      if (
        section.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      section.dataset.b45Ready =
        'true';

      const video = q(
        section,
        'video.b45-layer-video, video[data-b45-layer-video]'
      );

      if (!video) {
        return;
      }

      const phase = q(
        section,
        '[data-b45-layer-phase]'
      );

      const detail = q(
        section,
        '[data-b45-layer-detail]'
      );

      const fill = q(
        section,
        '[data-b45-layer-fill]'
      );

      const dot = q(
        section,
        '[data-b45-layer-dot]'
      );

      let duration = 10;
      let target = 0;
      let ready = false;
      let rafQueued = false;

      function copy(progress) {
        const phaseText =
          progress < 0.12
            ? 'Complete product'
            : progress < 0.43
              ? 'Separating construction'
              : progress < 0.72
                ? 'Construction layers revealed'
                : progress < 0.94
                  ? 'Recombining product'
                  : 'Complete product';

        const detailText =
          progress < 0.12
            ? 'Scroll to begin separating the Buffalo 45 construction.'
            : progress < 0.43
              ? 'The backing components move apart into clearly labelled positions.'
              : progress < 0.72
                ? 'Primary Backing, Geotextile Grid and PU and/or Latex coating are clearly revealed.'
                : progress < 0.94
                  ? 'Continue scrolling as the construction returns to the finished product.'
                  : 'Buffalo 45 is complete and ready for the next section.';

        if (phase) {
          phase.textContent =
            phaseText;
        }

        if (detail) {
          detail.textContent =
            detailText;
        }

        if (fill) {
          fill.style.height =
            `${progress * 100}%`;
        }

        if (dot) {
          dot.style.top =
            `${progress * 100}%`;
        }
      }

      function onScroll() {
        const rect =
          section.getBoundingClientRect();

        const travel =
          Math.max(
            1,
            section.offsetHeight -
            innerHeight
          );

        const progress =
          clamp(
            -rect.top /
            travel
          );

        target =
          progress *
          Math.max(
            0.01,
            duration - 0.04
          );

        copy(progress);
      }

      function tick() {
        if (
          ready &&
          Number.isFinite(
            video.duration
          )
        ) {
          const difference =
            target -
            video.currentTime;

          if (
            Math.abs(
              difference
            ) > 0.018
          ) {
            video.currentTime +=
              difference *
              0.34;
          }
        }

        requestAnimationFrame(
          tick
        );
      }

      function prepare() {
        duration =
          Number.isFinite(
            video.duration
          )
            ? video.duration
            : 10;

        ready = true;

        video.pause();

        onScroll();
      }

      video.addEventListener(
        'loadedmetadata',
        prepare,
        {
          once: true
        }
      );

      video.addEventListener(
        'canplay',
        () => {
          ready = true;
          video.pause();
        },
        {
          once: true
        }
      );

      if (
        video.readyState >= 1
      ) {
        prepare();
      }

      addEventListener(
        'scroll',
        () => {
          if (!rafQueued) {
            requestAnimationFrame(
              () => {
                onScroll();
                rafQueued =
                  false;
              }
            );

            rafQueued =
              true;
          }
        },
        {
          passive: true
        }
      );

      addEventListener(
        'resize',
        onScroll,
        {
          passive: true
        }
      );

      onScroll();

      requestAnimationFrame(
        tick
      );
    });
  }

  function initCoolTabs(root) {
    qa(
      root,
      '[data-b45-cool]'
    ).forEach((section) => {
      if (
        section.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      section.dataset.b45Ready =
        'true';

      const visual = q(
        section,
        '[data-b45-cool-visual]'
      );

      qa(
        section,
        '[data-b45-cool-mode]'
      ).forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            qa(
              section,
              '[data-b45-cool-mode]'
            ).forEach((item) => {
              item.classList.remove(
                'active'
              );

              item.setAttribute(
                'aria-selected',
                'false'
              );
            });

            button.classList.add(
              'active'
            );

            button.setAttribute(
              'aria-selected',
              'true'
            );

            if (visual) {
              visual.dataset.mode =
                button.dataset
                  .b45CoolMode;
            }
          }
        );
      });
    });
  }

  function initTriweave(root) {
    qa(
      root,
      '[data-b45-triweave]'
    ).forEach((section) => {
      if (
        section.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      section.dataset.b45Ready =
        'true';

      const stage = q(
        section,
        '[data-b45-blade-stage]'
      );

      const title = q(
        section,
        '[data-b45-focus-title]'
      );

      qa(
        section,
        '[data-b45-blade]'
      ).forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            qa(
              section,
              '[data-b45-blade]'
            ).forEach((item) => {
              item.classList.remove(
                'active'
              );
            });

            button.classList.add(
              'active'
            );

            if (stage) {
              stage.dataset.active =
                button.dataset
                  .b45Blade;
            }

            if (title) {
              title.textContent =
                button.dataset
                  .title ||
                '';
            }
          }
        );
      });
    });
  }

  function initSpecs(root) {
    qa(
      root,
      '[data-b45-specs]'
    ).forEach((section) => {
      if (
        section.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      section.dataset.b45Ready =
        'true';

      const buttons = qa(
        section,
        '[data-b45-spec-tab]'
      );

      const panels = qa(
        section,
        '[data-b45-spec-panel]'
      );

      buttons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              const tab =
                button.dataset
                  .b45SpecTab;

              buttons.forEach(
                (item) => {
                  item.classList.toggle(
                    'active',
                    item === button
                  );
                }
              );

              panels.forEach(
                (panel) => {
                  const active =
                    panel.dataset
                      .b45SpecPanel ===
                    tab;

                  panel.hidden =
                    !active;

                  if (
                    active &&
                    panel.animate
                  ) {
                    panel.animate(
                      [
                        {
                          opacity:
                            0.25,

                          transform:
                            'translateY(8px)'
                        },
                        {
                          opacity:
                            1,

                          transform:
                            'none'
                        }
                      ],
                      {
                        duration:
                          260
                      }
                    );
                  }
                }
              );
            }
          );
        }
      );
    });
  }

  function initFaq(root) {
    qa(
      root,
      '[data-b45-faq-item]'
    ).forEach((item) => {
      if (
        item.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      item.dataset.b45Ready =
        'true';

      const button = q(
        item,
        '[data-b45-faq-question]'
      );

      button?.addEventListener(
        'click',
        () => {
          const open =
            item.classList.toggle(
              'open'
            );

          button.setAttribute(
            'aria-expanded',
            String(open)
          );
        }
      );
    });
  }

  function initBackToBuy(root) {
    qa(
      root,
      '[data-b45-back-to-buy]'
    ).forEach((button) => {
      if (
        button.dataset
          .b45Ready === 'true'
      ) {
        return;
      }

      button.dataset.b45Ready =
        'true';

      button.addEventListener(
        'click',
        (event) => {
          if (
            button.tagName === 'A' &&
            button.getAttribute(
              'href'
            ) &&
            button.getAttribute(
              'href'
            ) !== '#top'
          ) {
            return;
          }

          event.preventDefault();

          document
            .querySelector(
              '[data-b45-hero]'
            )
            ?.scrollIntoView({
              behavior:
                'smooth',

              block:
                'start'
            });
        }
      );
    });
  }

  function initSticky(root) {
    const sticky = q(
      root,
      '[data-b45-sticky]'
    );

    const hero = q(
      root,
      '[data-b45-hero]'
    );

    if (
      !sticky ||
      !hero ||
      sticky.dataset.b45Ready ===
        'true'
    ) {
      return;
    }

    sticky.dataset.b45Ready =
      'true';

    const update = () => {
      const rect =
        hero.getBoundingClientRect();

      sticky.classList.toggle(
        'show',
        rect.bottom < 80 &&
        scrollY <
          document.body
            .scrollHeight -
          innerHeight -
          420
      );
    };

    addEventListener(
      'scroll',
      update,
      {
        passive: true
      }
    );

    addEventListener(
      'resize',
      update,
      {
        passive: true
      }
    );

    update();
  }

  /*
    IMPORTANT:

    This must remain .b45-page.

    Meadow 42, Plush 40 and Buffalo 45
    reuse this Premium page wrapper.
  */

  function init(
    root = document
  ) {
    qa(
      root,
      '.b45-page'
    ).forEach((page) => {
      initHero(page);
      initCompare(page);
      initReveal(page);
      initLayer(page);
      initCoolTabs(page);
      initTriweave(page);
      initSpecs(page);
      initFaq(page);
      initBackToBuy(page);
    });

    qa(
      document,
      '.b45-page'
    ).forEach(
      initSticky
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => init()
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      init(event.target)
  );
})();